import * as ArtistService from '../services';
import baseLogger from 'widget/logger';
import HttpError from 'widget/Errors/HttpError';
import qs from 'qs';
import { ArtistRadioResolvedProps } from 'widget/ArtistRadio/types';
import { getIdFromSlug } from 'state/Routing/helpers';
import { InitialProps, InstanceMethods } from 'widget/PodcastProfile/types';
import { makeArtistStationPath } from 'widget/utils/helpers/selectors';
import { pick } from 'lodash-es';
import { TrackingStationType } from 'widget/types/widgetTrackingConfig';
import { WIDGET_DIMENSIONS } from 'constants/widgetDimensions';
import { WidgetLocationConfig } from 'widget/types';

export default async function getInitialProps(
  { params, query }: InitialProps,
  { logger = baseLogger, transport }: InstanceMethods,
  {
    api,
    countryCode = '',
    links = { radioEditMediaServer: '' },
    featureFlags = { customRadio: true, pivotGeoEnabled: false },
    supportedCountries = [],
    websiteUrl = '',
  }: WidgetLocationConfig,
): Promise<ArtistRadioResolvedProps> {
  const { id: urlId } = params;
  const { autoplay } = query;
  const artistId = getIdFromSlug(urlId);

  if (!artistId) throw new HttpError(400, 'artist id missing.');

  const artistData = await ArtistService.fetchArtist({
    ampUrl: api.server,
    artistId,
    logger,
    transport,
  });

  const noMatch = !artistData;

  const { artist, relatedTo, tracks } = artistData ?? {};
  const { name, image } = artist ?? {};

  const slugifiedId = makeArtistStationPath(String(name), String(artistId));

  // analytics query string parameters indicating the user visited the artist from widget
  const trackParamsforLandingUrls = {
    keyid: name,
    pname: 'artist_profile',
    sc: 'widget_share',
  };

  const baseArtistUrl = `${websiteUrl}${slugifiedId}`;

  const metaDescription = tracks
    .slice(0, 3)
    .map(track => track.name)
    .join(', ');

  return {
    ampUrl: api.client,
    artistId,
    baseArtistUrl,
    artistUrl: `${baseArtistUrl}?${qs.stringify(trackParamsforLandingUrls)}`,
    autoplay: !!autoplay,
    countryCode,
    customRadioEnabled: featureFlags.customRadio,
    dimensions: { ...WIDGET_DIMENSIONS.ARTIST },
    description: metaDescription,
    embedUrl: `${baseArtistUrl}?${qs.stringify(
      pick(query, ['embed', 'theme']),
    )}`,
    followUrl: `${baseArtistUrl}?${qs.stringify({
      ...trackParamsforLandingUrls,
      follow: true,
    })}`,
    image,
    links,
    name,
    noMatch,
    similarArtists: relatedTo,
    similarArtistsUrl: `${baseArtistUrl}similar/?${qs.stringify(
      trackParamsforLandingUrls,
    )}`,
    stationArtist: artist,
    stationType: TrackingStationType.CUSTOM,
    supportedCountries,
    websiteUrl: `${websiteUrl}/?${qs.stringify(trackParamsforLandingUrls)}`,
  };
}
